export default "__VITE_ASSET__DEYOrnHy__"